export const state = () => ({
  newDeposit: { limit: 10 },
  pendingDeposit: { limit: 10 },
  historyDeposit: { limit: 10 },
  newWithdraw: { limit: 10 },
  pendingWithdraw: { limit: 10 },
  historyWithdraw: { limit: 10 }
})

export const actions = {
  // Get all events
  resetDepositPagination({ commit }) {
    const limit = { limit: 10 }
    commit('newDeposit', limit)
    commit('pendingDeposit', limit)
    commit('historyDeposit', limit)
  },
  resetWithdrawalPagination({ commit }) {
    const limit = { limit: 10 }
    commit('newWithdraw', limit)
    commit('pendingWithdraw', limit)
    commit('historyWithdraw', limit)
  }
}

export const mutations = {
  newDeposit(state, type) {
    state.newDeposit = type
  },
  pendingDeposit(state, type) {
    state.pendingDeposit = type
  },
  historyDeposit(state, type) {
    state.historyDeposit = type
  },
  newWithdraw(state, type) {
    state.newWithdraw = type
  },
  pendingWithdraw(state, type) {
    state.pendingWithdraw = type
  },
  historyWithdraw(state, type) {
    state.historyWithdraw = type
  }
}
